/** CKEditor 이미지 업로드 어댑터 (최대 3장, 800px 리사이즈, JPEG 0.7 압축) */
export class MyUploadAdapter {
    loader: any;
    editor: any;
    constructor(loader: any, editor: any) {
        this.loader = loader;
        this.editor = editor;
    }
    upload() {
        return this.loader.file.then((file: any) => new Promise((resolve, reject) => {
            const data = this.editor.getData();
            const imageCount = (data.match(/<img/g) || []).length;
            if (imageCount >= 3) {
                alert('이미지는 최대 3개까지만 등록 가능합니다.');
                reject('Image limit exceeded');
                return;
            }
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (event: any) => {
                const img = new Image();
                img.src = event.target.result;
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const MAX_WIDTH = 800;
                    let width = img.width;
                    let height = img.height;
                    if (width > MAX_WIDTH) { height *= MAX_WIDTH / width; width = MAX_WIDTH; }
                    canvas.width = width;
                    canvas.height = height;
                    canvas.getContext('2d')?.drawImage(img, 0, 0, width, height);
                    resolve({ default: canvas.toDataURL('image/jpeg', 0.7) });
                };
                img.onerror = reject;
            };
            reader.onerror = reject;
        }));
    }
    abort() {}
}

export function MyCustomUploadAdapterPlugin(editor: any) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => new MyUploadAdapter(loader, editor);
}
